import { render, staticRenderFns } from "./EpgSources.vue?vue&type=template&id=6cba779a"
import script from "./EpgSources.vue?vue&type=script&lang=js"
export * from "./EpgSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports